module.exports = __webpack_public_path__ + "img/bg.04c160fd.jpg";